import { render, staticRenderFns } from "./featured-products-grid.vue?vue&type=template&id=4af26fce&scoped=true"
import script from "./featured-products-grid.vue?vue&type=script&lang=js"
export * from "./featured-products-grid.vue?vue&type=script&lang=js"
import style0 from "./featured-products-grid.vue?vue&type=style&index=0&id=4af26fce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af26fce",
  null
  
)

export default component.exports